import {External, M} from "../external";
import {getUTMSalesTotals} from "../Store/static";

export const REGULAR = 1;
export const AB_CONTENT = 2;
export const AB_SUBJECT = 3;
export const SMS = 4;
export const WHATSAPP = 5;
export const VOICE = 6;

export const WIN_TYPE_OPEN = 1;
export const WIN_TYPE_CLICK = 2;

export const DEFAULT_UNSUBSCRIBE_BLOCK = {
  style: {
    backgroundColor: "transparent",
    paddingBottom: "20px",
    color: "#969AA1",
    position: "center",
    paddingTop: "20px"
  },
  label: M.UNSUBSCRIBE,
  type: "unsubscribe"
};

export const DEFAULT_HTML_EMAIL_CONTENT = 'Enter your HTML markup. \n\n<br /><br /><br /><br />\n\n\n{company_name} | {company_address} | <a href="{unsubscribe_link}">' + M.UNSUBSCRIBE + '</a>';

export const DEFAULT_TEXT_EMAIL_CONTENT = {
  isTextEmail: true,
  style: { backgroundColor: "#ffffff", fontFamily: "Arial", width: "590px", align: "left" },
  content: [
    {
      style: { backgroundColor: "transparent", paddingBottom: "25px", color: "#000000", paddingTop: "0px" },
      content:
        '<div><span style="text-align: left; font-size: 16px; line-height: 1.6;color: rgb(97, 97, 97);">Hi {name},<br /><br />' +
        M.LOREM_IPSUM +
        "<br /><br />" +
        M.LOREM_IPSUM +
        "<br /><br />Regards,<br />Name</span></div>"
    }, DEFAULT_UNSUBSCRIBE_BLOCK
  ]
};

export function getSubscribers(data, onDone) {
  External.Tools.makeWebsiteRequest({
    action: "getCampaignAudience",
    data: {
      lists: JSON.stringify(data.lists),
      segments: JSON.stringify(data.segments)
    },
    onOk: function (response) {
      if (response.data == null) {
        return;
      }
      onDone(response.data);
    }
  });
}

export function getLists(onDone) {
  External.Tools.makeWebsiteRequest({
    action: "getMarketingLists",
    data: {
      withStats: false
    },
    onOk: function (response) {
      if (response.data == null) {
        return;
      }

      onDone(response.data);
    }
  });
}

export function getSegments(onDone) {
  External.Tools.makeWebsiteRequest({
    action: "getMarketingSegments",
    data: {
      withStats: false,
      withSubscriberCount: true
    },
    onOk: function (response) {
      if (response.data == null) {
        return;
      }

      onDone(response.data);
    }
  });
}

export function sendTestEmail(campaign, defaultEmail) {
  //External.Tools.promptForInput(M.SEND_TEST_EMAIL, M.ENTER_EMAIL_TEST_CAMPAIGN, defaultEmail || "", function (email) {
    External.Tools.makeWebsiteRequest({
      action: "sendMarketingCampaignTestEmail",
      data: {
        id: campaign.id,
    //    toRecipient: email
      },
      onOk: function () {
        External.Tools.showAutohideMessage(5, External.userEmail + ' - ' + M.TEST_MESSAGE_SENT);
      }
    });
  //});
}

export function getCRMMessageChannelType(campaignType) {
  switch (campaignType) {
    case SMS:       return External.CRM_MESSAGE_CHANNEL.SMS;
    case WHATSAPP:  return External.CRM_MESSAGE_CHANNEL.WHATSAPP;
    case VOICE:     return External.CRM_MESSAGE_CHANNEL.VOICE;
  }
  return undefined;
}

export function validate(step, data) {
  return {
    name: function () {
      if (!data.name) {
        External.Tools.showError(M.INSERT_CAMPAIGN_NAME);
        return false;
      }

      return true;
    },
    type: function () {
      if (!data.type) {
        External.Tools.showError(M.SELECT_CAMPAIGN_TYPE);
        return false;
      }

      return true;
    },
    design: function () {
      if (!data.content) {
        External.Tools.showError(M.SELECT_CAMPAIGN_DESIGN);
        return false;
      }

      return true;
    },
    recipients: function () {
      if (data.data.lists.length === 0 && data.data.segments.length === 0) {
        External.Tools.showError(M.SELECT_LIST_SEGMENT);
        return false;
      }
      if (data.type !== REGULAR && data.data.audience < 10) {
        External.Tools.showError(M.SPLIT_TEST_REQUREMENTS);
        return false;
      }
      return true;
    },
    summary: function () {
      let domains = data.domains;
      let statuses = data.statuses;

      let invalidFields = [];
      if (!data.subject) {
        invalidFields.push(M.SUBJECT);
      }

      if (!data.replyTo) {
        invalidFields.push(M.REPLYTO);
      }

      if (!data.fromName) {
        invalidFields.push(M.NAME);
      }

      if (!data.fromEmail) {
        invalidFields.push(M.EMAIL);
      }

      if (invalidFields.length > 0) {
        External.Tools.showError(M.FILL_REQUIRED_FIELDS + "&nbsp;" + invalidFields.join(", "));
        return false;
      }

      let emailParts = data.replyTo.split("@");
      if (emailParts.length != 2 || data.replyTo.length < 5) {
        External.Tools.showError(M.WRONG_EMAIL_REPLY);
        return false;
      }

      emailParts = data.fromEmail.split("@");
      if (emailParts.length != 2 || data.fromEmail.length < 5) {
        External.Tools.showError(M.WRONG_EMAIL_EMAIL);
        return false;
      }

      if (
        !domains ||
        domains.indexOf(emailParts[1]) <= -1 ||
        (domains.indexOf(emailParts[1]) > -1 && statuses[domains.indexOf(emailParts[1])] != "VERIFIED")
      ) {
        External.Tools.showError(M.EMAIL_NOT_VERIFIED);
        return false;
      }

      if (data.data.salesUtm) {
        if (!data.data.salesUtm.campaign?.length) {
          External.Tools.showError(M.INVALID_UTM_CAMPAIGN);
          return false;
        }
      }

      return true;
    },
    send: function () {
      return true;
    }
  }[step]();
}

export async function getCampaignSalesTotals(campaign) {
  const fromDate = new Date(campaign.modified.epochSecond * 1000);
  return await getUTMSalesTotals(fromDate, new Date(), campaign.data.salesUtm);
}
